<section class="p-b-16">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px" class="m-t-16 no print">
      <div fxLayout="row" fxLayoutGap="8px">
        <button type="button" mat-stroked-button color="primary" (click)="exportToPdf(pdf)">
          Export to PDF
        </button>

        <button type="button" mat-stroked-button color="warn" (click)="cancel()">Close</button>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button type="button" mat-stroked-button color="primary" [disabled]="!complaintInspections.length" (click)="setAllInspectionNarratives(true)">
          Expand All
        </button>

        <button type="button" mat-stroked-button [disabled]="!complaintInspections.length" (click)="setAllInspectionNarratives(false)">
          Minimize All
        </button>
      </div>
    </div>
  </section>
  <mat-dialog-content>
    <kendo-pdf-export #pdf
                      paperSize="letter"
                      [scale]="0.75"
                      margin="1cm"
                      keepTogether="span,.pdf-table-section,mat-header-row,mat-row,.mat-header-row,.mat-row">
  
                      <div fxLayout="column">
                          <div class="complaint-header detail-grid" fxFlex>
                            <div class="detail-field detail-field-half header-field" fxFlex.lt-md="100">
                              <span class="detail-label">Complaint Number</span>
                              <span class="detail-value">{{complaint.complaintNumber}}</span>
                            </div>
                            <div class="detail-field detail-field-half header-field" fxFlex.lt-md="100">
                              <span class="detail-label">Status</span>
                              <span class="detail-value">{{complaint.status}}</span>
                            </div>
                          </div>
                          <mat-card-content>
                              <mat-card class="detail-card section-shell source-section-shell" fxLayout="column" fxLayoutGap="4px">
                                <span class="section-title"><strong>Complaint Source Details</strong></span>
                                <div class="detail-grid">
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">First Name</span>
                                    <span class="detail-value">{{complaint.complainteeFirstName}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Last Name</span>
                                    <span class="detail-value">{{complaint.complainteeLastName}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Address</span>
                                    <span class="detail-value">{{complaint.complainteeAddress}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">City</span>
                                    <span class="detail-value">{{complaint.complainteeCity}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">State</span>
                                    <span class="detail-value">{{complaint.complainteeState}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Zip</span>
                                    <span class="detail-value">{{complaint.complainteeZip}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Employer</span>
                                    <span class="detail-value">{{complaint.complainteeEmployer}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Complaint Date</span>
                                    <span class="detail-value">{{complaint.complaintDate | date}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Phone</span>
                                    <span class="detail-value">{{complaint.complainteePhone}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Email</span>
                                    <span class="detail-value">{{complaint.complainteeEmail}}</span>
                                  </div>
                                </div>
                              </mat-card>
                            </mat-card-content>
                            <mat-card-content>
                              <mat-card class="detail-card section-shell target-section-shell" fxLayout="column" fxLayoutGap="4px">
                                <span class="section-title"><strong>Complaint Target Details</strong></span>
                                <div class="detail-grid">
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Association Name</span>
                                    <span class="detail-value">{{complaint.complaintAssociationName}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Other Worker</span>
                                    <span class="detail-value">{{complaint.otherWorker}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Address</span>
                                    <span class="detail-value">{{complaint.complainantAddress}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">City</span>
                                    <span class="detail-value">{{complaint.complainantCity}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">State</span>
                                    <span class="detail-value">{{complaint.complainantState}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Zip</span>
                                    <span class="detail-value">{{complaint.complainantZip}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Contractor 1</span>
                                    <span class="detail-value">{{complaint.complaintContractor1}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Contractor CCB 1</span>
                                    <span class="detail-value">{{complaint.contractorCCB1}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Contractor 2</span>
                                    <span class="detail-value">{{complaint.complaintContractor2}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Contractor CCB 2</span>
                                    <span class="detail-value">{{complaint.contractorCCB2}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Contractor 3</span>
                                    <span class="detail-value">{{complaint.complaintContractor3}}</span>
                                  </div>
                                  <div class="detail-field detail-field-half" fxFlex.lt-md="100">
                                    <span class="detail-label">Contractor CCB 3</span>
                                    <span class="detail-value">{{complaint.contractorCCB3}}</span>
                                  </div>
                                </div>
                              </mat-card>
                            </mat-card-content>
                            <mat-card-content fxLayout="column" fxLayoutGap="16px">
                              <div class="complaint-details-row" fxLayout="row">
                                <mat-card class="detail-card section-shell" fxFlex="100">
                                  <div class="detail-field detail-field-full">
                                    <span class="detail-label">Complaint Details</span>
                                    <span class="detail-value">{{complaint.complaintProblem}}</span>
                                  </div>
                                </mat-card>
                              </div>
                              <div class="summary-pair-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px" fxFlex="100">
                                  <mat-card class="detail-card section-shell summary-pair-card">
                                    <div class="detail-field detail-field-full">
                                      <span class="detail-label">Jurisdictions</span>
                                      <span class="detail-value">{{complaintJurisdictions}}</span>
                                    </div>
                                  </mat-card>
                                  <mat-card class="detail-card section-shell summary-pair-card">
                                    <div class="detail-field detail-field-full">
                                      <span class="detail-label">Enforcement Categories</span>
                                      <span class="detail-value">{{complaintEnforcementCategory}}</span>
                                    </div>
                                  </mat-card>
                              </div>
                                <div class="summary-pair-row summary-pair-row-spaced" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px" fxFlex="100">
                                  <mat-card class="detail-card section-shell summary-pair-card">
                                    <div class="detail-field detail-field-full">
                                      <span class="detail-label">Investigator Assigned</span>
                                      <span class="detail-value">{{complaint.complaintInvestigator || 'N/A'}}</span>
                                    </div>
                                  </mat-card>
                                  <mat-card class="detail-card section-shell summary-pair-card">
                                    <div class="detail-field detail-field-full">
                                      <span class="detail-label">Date Assigned</span>
                                      <span class="detail-value">{{complaint.investigatorAssignedDate ? (complaint.investigatorAssignedDate | date) : 'N/A'}}</span>
                                    </div>
                                  </mat-card>
                                </div>
                            </mat-card-content>
                           <mat-card class="custom-mat-card table-shell pdf-table-section">
                            <mat-card-title>
                                <div fxLayout="row">
                                    <span>Complaint Referral</span>
                                </div>
                            </mat-card-title>
                            <mat-card-content>
                                <ng-container>
                                    <div fxLayout="column" fxLayoutGap="8px">
                                        <mat-table [dataSource]="complaintReferralsDataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                                            <ng-container *ngFor="let cellData of complaintReferralTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                                                <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{cellData.displayName}}</mat-header-cell>
                                                <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}">
                                                    <ng-container *ngIf="cellData.type === 'date'">
                                                        <div *ngIf="isMobile" fxLayout="row">  
                                                            <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                            <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                                        </div>
                                                        <div *ngIf="!isMobile">  
                                                            {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                                                        </div>
                                                      </ng-container>
                                                      <ng-container *ngIf="cellData.type === 'boolean'">
                                                        <div *ngIf="isMobile" fxLayout="row">
                                                            <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                            <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                                        </div>
                                                        <div *ngIf="!isMobile">
                                                            <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                                        </div>                            
                                                      </ng-container>
                                                      <ng-container *ngIf="cellData.type !== 'date' && cellData.type !== 'boolean'">
                                                        <ng-container *ngIf="cellData.columnName === 'status'; else notStatus">
                                                            <div class="status-card">
                                                                <div *ngIf="isMobile" fxLayout="row">  
                                                                    <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                                    <span>{{row[cellData.columnName]}}</span>
                                                                </div>
                                                                <div *ngIf="!isMobile">  
                                                                    {{row[cellData.columnName]}}
                                                                </div>                                    
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #notStatus> 
                                                        <div *ngIf="isMobile" fxLayout="row">                                    
                                                            <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                                            <span>{{ displayLimit(row[cellData.columnName], getPreviewLimit(cellData)) }}</span>
                                                        </div>
                                                        <div *ngIf="!isMobile">
                                                            {{displayLimit(row[cellData.columnName], getPreviewLimit(cellData))}}
                                                        </div> 
                                                        </ng-template> 
                                                      </ng-container>
                                                </mat-cell>
                                            </ng-container>    
                                            <!-- Column definitions -->
                                            <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="complaintReferralTable.layout.columns"></mat-header-row>
                                            <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; index as i; columns: complaintReferralTable.layout.columns"></mat-row>
                                          </mat-table>            
                                    </div>
                        </ng-container>
                    </mat-card-content>
                    </mat-card>
                    <mat-card class="custom-mat-card table-shell pdf-table-section">
                        <mat-card-title>
                            <div fxLayout="row">
                                <span>Complaint Associations</span>
                            </div>
                        </mat-card-title>
                        <mat-card-content>
                            <ng-container>
                                <div fxLayout="column" fxLayoutGap="8px">
                                    <mat-table [dataSource]="complaintAssocationDataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                                        <ng-container *ngFor="let cellData of complaintAssociationTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                                            <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{cellData.displayName}}</mat-header-cell>
                                            <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}">
                                                <ng-container *ngIf="cellData.type === 'date'">
                                                    <div *ngIf="isMobile" fxLayout="row">  
                                                        <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                        <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                                    </div>
                                                    <div *ngIf="!isMobile">  
                                                        {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                                                    </div>
                                                  </ng-container>
                                                  <ng-container *ngIf="cellData.type === 'boolean'">
                                                    <div *ngIf="isMobile" fxLayout="row">
                                                        <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                        <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                                    </div>
                                                    <div *ngIf="!isMobile">
                                                        <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                                    </div>                            
                                                  </ng-container>
                                                  <ng-container *ngIf="cellData.type !== 'date' && cellData.type !== 'boolean'">
                                                    <ng-container *ngIf="cellData.columnName === 'status'; else notStatus">
                                                        <div class="status-card">
                                                            <div *ngIf="isMobile" fxLayout="row">  
                                                                <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                                <span>{{row[cellData.columnName]}}</span>
                                                            </div>
                                                            <div *ngIf="!isMobile">  
                                                                {{row[cellData.columnName]}}
                                                            </div>                                    
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #notStatus> 
                                                    <div *ngIf="isMobile" fxLayout="row">                                    
                                                        <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                                                <span>{{ displayLimit(row[cellData.columnName], getPreviewLimit(cellData)) }}</span>
                                                    </div>
                                                    <div *ngIf="!isMobile">
                                                                  {{displayLimit(row[cellData.columnName], getPreviewLimit(cellData))}}
                                                    </div> 
                                                    </ng-template> 
                                                  </ng-container>
                                            </mat-cell>
                                        </ng-container>    
                                        <!-- Column definitions -->
                                        <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="complaintAssociationTable.layout.columns"></mat-header-row>
                                        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; index as i; columns: complaintAssociationTable.layout.columns"></mat-row>
                                      </mat-table>            
                                </div>
                    </ng-container>
                </mat-card-content>
                </mat-card>
                <mat-card class="custom-mat-card table-shell pdf-table-section">
                    <mat-card-title>
                        <div fxLayout="row">
                            <span>Complaint Actions</span>
                        </div>
                    </mat-card-title>
                    <mat-card-content>
                        <ng-container>
                            <div fxLayout="column" fxLayoutGap="8px">
                                <mat-table [dataSource]="complaintActionDataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                                    <ng-container *ngFor="let cellData of complaintActionTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                                        <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{cellData.displayName}}</mat-header-cell>
                                        <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}">
                                            <ng-container *ngIf="cellData.type === 'date'">
                                                <div *ngIf="isMobile" fxLayout="row">  
                                                    <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                    <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                                </div>
                                                <div *ngIf="!isMobile">  
                                                    {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                                                </div>
                                              </ng-container>
                                              <ng-container *ngIf="cellData.type === 'boolean'">
                                                <div *ngIf="isMobile" fxLayout="row">
                                                    <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                    <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                                </div>
                                                <div *ngIf="!isMobile">
                                                    <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                                </div>                            
                                              </ng-container>
                                              <ng-container *ngIf="cellData.type !== 'date' && cellData.type !== 'boolean'">
                                                <ng-container *ngIf="cellData.columnName === 'status'; else notStatus">
                                                    <div class="status-card">
                                                        <div *ngIf="isMobile" fxLayout="row">  
                                                            <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                            <span>{{row[cellData.columnName]}}</span>
                                                        </div>
                                                        <div *ngIf="!isMobile">  
                                                            {{row[cellData.columnName]}}
                                                        </div>                                    
                                                    </div>
                                                </ng-container>
                                                <ng-template #notStatus> 
                                                <div *ngIf="isMobile" fxLayout="row">                                    
                                                    <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                                    <span>{{ displayLimit(row[cellData.columnName], getPreviewLimit(cellData)) }}</span>
                                                </div>
                                                <div *ngIf="!isMobile">
                                                      {{displayLimit(row[cellData.columnName], getPreviewLimit(cellData))}}
                                                </div> 
                                                </ng-template> 
                                              </ng-container>
                                        </mat-cell>
                                    </ng-container>    
                                    <!-- Column definitions -->
                                    <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="complaintActionTable.layout.columns"></mat-header-row>
                                    <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; index as i; columns: complaintActionTable.layout.columns"></mat-row>
                                  </mat-table>            
                            </div>
                </ng-container>
            </mat-card-content>
            </mat-card>
            <mat-card class="custom-mat-card table-shell pdf-inspection-section">
                <mat-card-title>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px" class="inspection-title-row">
                  <span>Complaint Inspection/Narrative/Followup</span>
                </div>
                </mat-card-title>
                <mat-card-content>
                      <ng-container *ngIf="complaintInspectionTable.layout.container[3] as inspectionDetailsColumn">
                        <div fxLayout="column" fxLayoutGap="8px">
                          <table class="pdf-inspection-table">
                            <colgroup>
                              <col class="inspection-col-date">
                              <col class="inspection-col-type">
                              <col class="inspection-col-scope">
                              <col class="inspection-col-details">
                            </colgroup>
                            <thead>
                              <tr>
                                <th>Date of Inspection</th>
                                <th>Inspection Type</th>
                                <th>Scope</th>
                                <th>Inspection Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let displayRow of complaintInspectionDisplayRows" [class.inspection-continuation-row]="displayRow.isContinuation">
                                <td>{{ displayRow.inspectionDate ? (displayRow.inspectionDate | date:'MM/dd/yyyy') : '' }}</td>
                                <td>{{ displayRow.inspectionType }}</td>
                                <td>{{ displayRow.scope }}</td>
                                <td class="inspection-details-column">
                                  <div class="inspection-details-cell pdf-inspection-details-cell">
                                    <div class="inspection-details-text" [class.expanded]="isInspectionNarrativeExpanded(displayRow.sourceRow)">
                                      {{ displayRow.inspectionDetails }}
                                    </div>
                                    <button
                                      *ngIf="!displayRow.isContinuation && !isExportingPdf && (canExpandInspectionNarrative(displayRow.sourceRow, inspectionDetailsColumn) || isInspectionNarrativeExpanded(displayRow.sourceRow))"
                                      type="button"
                                      mat-button
                                      color="primary"
                                      class="inspection-toggle"
                                      (click)="toggleInspectionNarrative(displayRow.sourceRow)">
                                      {{ isInspectionNarrativeExpanded(displayRow.sourceRow) ? 'Minimize' : 'Expand' }}
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </ng-container>
        </mat-card-content>
        </mat-card>
        <mat-card class="custom-mat-card table-shell pdf-table-section">
            <mat-card-title>
                <div fxLayout="row">
                    <span>Complaint Owner/Tenant</span>
                </div>
            </mat-card-title>
            <mat-card-content>
                <ng-container>
                    <div fxLayout="column" fxLayoutGap="8px">
                        <mat-table [dataSource]="complaintOwnerTenantDataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                            <ng-container *ngFor="let cellData of complaintOwnerTenantTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                                <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{cellData.displayName}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}">
                                    <ng-container *ngIf="cellData.type === 'date'">
                                        <div *ngIf="isMobile" fxLayout="row">  
                                            <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                            <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                        </div>
                                        <div *ngIf="!isMobile">  
                                            {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                                        </div>
                                      </ng-container>
                                      <ng-container *ngIf="cellData.type === 'boolean'">
                                        <div *ngIf="isMobile" fxLayout="row">
                                            <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                            <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                        </div>
                                        <div *ngIf="!isMobile">
                                            <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                        </div>                            
                                      </ng-container>
                                      <ng-container *ngIf="cellData.type !== 'date' && cellData.type !== 'boolean'">
                                        <ng-container *ngIf="cellData.columnName === 'status'; else notStatus">
                                            <div class="status-card">
                                                <div *ngIf="isMobile" fxLayout="row">  
                                                    <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                                    <span>{{row[cellData.columnName]}}</span>
                                                </div>
                                                <div *ngIf="!isMobile">  
                                                    {{row[cellData.columnName]}}
                                                </div>                                    
                                            </div>
                                        </ng-container>
                                        <ng-template #notStatus> 
                                        <div *ngIf="isMobile" fxLayout="row">                                    
                                            <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                            <span>{{ displayLimit(row[cellData.columnName], getPreviewLimit(cellData)) }}</span>
                                        </div>
                                        <div *ngIf="!isMobile">
                                            {{displayLimit(row[cellData.columnName], getPreviewLimit(cellData))}}
                                        </div> 
                                        </ng-template> 
                                      </ng-container>
                                </mat-cell>
                            </ng-container>    
                            <!-- Column definitions -->
                            <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="complaintOwnerTenantTable.layout.columns"></mat-header-row>
                            <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; index as i; columns: complaintOwnerTenantTable.layout.columns"></mat-row>
                          </mat-table>            
                    </div>
        </ng-container>
    </mat-card-content>
    </mat-card>
                      </div>

      <ng-template #compliancePlanRuleTemplate let-compliancePlanRule="compliancePlanRule">
        <mat-card>
          <mat-card-content>
            <mat-card  fxLayout="column" fxLayoutGap="16px">
         
    </mat-card>
          </mat-card-content>
        </mat-card>
      </ng-template>
  
    </kendo-pdf-export>
  </mat-dialog-content>
